export const SECRET = 'qEIoonWmoK88ENS2ERkcO4grX2YZSNer9fh6JhcG'
